import _ from 'underscore';
import Backbone from 'backbone';
import Session from './Session';
import SessionsCollection from './SessionsCollection';
import '../backbone-relational-isomorphic';

var SessionGroup = Backbone.RelationalModel.extend({
    relations: [
        {
            type: Backbone.HasMany,
            key: 'sessions',
            relatedModel: Session,
            collectionType: SessionsCollection
        }
    ],

    initialize: function() {
    }

});
export default SessionGroup;

